import EventForm from './EventForm';
//
// Компонент для создания мероприятия
//
const EventAdd = () => {
    return (
		<EventForm event={null}/>
	);
};

export default EventAdd;
